module.exports = __webpack_public_path__ + "img/analytics2.d211ebd7.svg";